// extracted by mini-css-extract-plugin
module.exports = {"container":"container__3Unsq","text":"text__1p0gb","visible":"visible__1pB_E","hidden":"hidden__1JfuK","closeButton":"closeButton__1JFAV"};